// extracted by mini-css-extract-plugin
export default {"header_box":"index_header_box_4HTXe","header":"index_header_6aiJh clearfix"};